import(/* webpackMode: "eager" */ "/vercel/path0/src/app/registrierung/page.tsx");
